/* eslint-disable no-unused-vars */
import axios from 'utils/axios/modules/tanakaId'
import { useState, useCallback } from 'react'
import { useParams } from 'react-router-dom'

function useTanakaIdHook() {
  const { token } = useParams()

  const [isRequestingAPI, setIsRequestingAPI] = useState(false)
  const [successes, setSuccesses] = useState([])
  const [errors, setErrors] = useState([])

  const confirmTanakaId = useCallback(async () => {
    setIsRequestingAPI(true)

    await axios
      .confirmTanakaId(token)
      .then((response) => {
        if (response?.data?.content?.message) {
          setSuccesses(response.data.content.message)
        }
      })
      .catch((errorMessages) => {
        setErrors(errorMessages)
      })

    setIsRequestingAPI(false)
  }, [token])

  return {
    errors,
    successes,
    isRequestingAPI,
    confirmTanakaId,
  }
}

export default useTanakaIdHook
